export default "__VITE_ASSET__72b9e2d8__"